import { defineMessages } from 'react-intl';
/**
 * These messages is a union from other messages, the long term plan is to move all messages owned by
 * sdk-connectivity to this file
 */

export const messages = defineMessages({
  authorizeHeader: {
    defaultMessage: 'Waiting for authentication',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.authorizeHeader',
  },
  consentInformation: {
    defaultMessage:
      'Make sure to give consent for account balance and transaction in {providerName} for this service to work',
    id: 'AwaitingThirdpartyAuthentication.consentInformation',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'AddCredentialsPage.continue',
  },
  instructionsPayAuth: {
    defaultMessage: 'To continue, follow the instructions at {providerName} ',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.instructionsPayAuth',
  },
  logInToYourBank: {
    defaultMessage: 'Log in to your bank',
    id: 'AddCredentialsPage.logInToYourBank',
  },
  logInToYourBankParametrized: {
    defaultMessage: `Log in to {providerName}`,
    id: 'AddCredentialsPage.logInToYourBankParametrized',
  },
  openProvider: {
    defaultMessage: 'Open {providerName}',
    id: 'AwaitingThirdpartyAuthentication.openProvider',
  },
  openProviderToLogIn: {
    defaultMessage: 'Open {providerName} log in',
    id: 'AwaitingThirdpartyAuthentication.buttonText',
  },
  providerInfo: {
    defaultMessage: "Can't see the {providerName} login window?",
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.providerInfo',
  },
  redirectInstructionsStep1: {
    defaultMessage: 'You will be securely transferred to {providerName}.',
    id: 'AwaitingThirdpartyAuthentication.step1',
  },
  redirectInstructionsStep2: {
    defaultMessage: 'You will be required to authenticate.',
    id: 'AwaitingThirdpartyAuthentication.step2',
  },
  redirectInstructionsStep3: {
    defaultMessage:
      'Once authenticated, you will be redirected back to {clientName}{isAbbreviated, select, true {} other {.}}',
    id: 'AwaitingThirdpartyAuthentication.step3',
  },
  'RedirectThirdParty.title': {
    defaultMessage: 'Transferring you to {providerName}...',
    id: 'RedirectThirdParty.title',
  },
  'RedirectThirdParty.transfered': {
    defaultMessage: 'Not being transferred automatically?',
    id: 'RedirectThirdParty.transfered',
  },
  'RedirectThirdParty.continue': {
    defaultMessage: 'Click to continue',
    id: 'RedirectThirdParty.continue',
  },
  continueTo: {
    defaultMessage: 'Continue to {providerName}',
    id: 'RedirectThirdParty.continueTo',
  },
  redirectedTo: {
    defaultMessage: "You'll be redirected to {providerName} to log in to connect your account.",
    id: 'RedirectThirdParty.redirectedTo',
  },
  retry: {
    defaultMessage: 'Click to open',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.retry',
  },
  securityCaption: {
    defaultMessage: 'Your bank login details are only visible to you',
    id: 'AwaitingThirdpartyAuthentication.securityCaption',
  },
  title: {
    defaultMessage: 'Authenticate with {providerName}',
    id: 'AwaitingThirdpartyAuthentication.title',
  },
  titleApp: {
    defaultMessage: 'Authenticate with the {providerAppName} app',
    id: 'AwaitingThirdpartyAuthentication.titleApp',
  },
  openingApp: {
    defaultMessage: 'Opening {providerName} App',
    id: 'DeviceHandoff.openingApp',
  },
  open: {
    defaultMessage: 'Open',
    id: 'AwaitingThirdpartyAuthenticationLocalPrompt.open',
  },
  'HandoffCompleted.done': {
    defaultMessage: "You're done. Go back to {clientName}.",
    id: 'HandoffCompleted.done',
  },
  codeScannedTitle: {
    defaultMessage: 'QR code successfully scanned',
    id: 'AddCredentialsPage.codeScannedTitle',
  },
  codeScannedInstructions: {
    defaultMessage: 'To continue, follow the instructions in the {providerName} app',
    id: 'AddCredentialsPage.codeScannedInstructions',
  },
  qrCodeCaption: {
    defaultMessage: 'QR code for bank authentication on your phone',
    id: 'Handoff.qrCodeCaption',
  },
  openCamera: {
    defaultMessage: 'Open your mobile phone camera and scan the QR code.',
    id: 'Handoff.openCamera',
  },
  followLink: {
    defaultMessage: 'Follow the link to authenticate securely.',
    id: 'Handoff.followLink',
  },
  continueHere: {
    defaultMessage: 'Once authenticated, you will continue here.',
    id: 'Handoff.continueHere',
  },
  authenticateWith: {
    defaultMessage: 'Authenticate with the {providerName} app',
    id: 'Handoff.authenticateWith',
  },
  desktopSignIn: {
    defaultMessage: 'Log in from desktop instead',
    id: 'AddCredentialsPage.desktopSignIn',
  },
  readMore: {
    defaultMessage: 'Read More',
    id: 'ScopesList.readMore',
  },
  close: {
    defaultMessage: 'Close',
    id: 'InfoOverlay.close',
  },
  privacyPolicy: {
    defaultMessage: 'Privacy Policy',
    id: 'LegalDisclaimer.privacyPolicy',
  },
  termsAndConditions: {
    defaultMessage: 'Terms and Conditions',
    id: 'LegalDisclaimer.termsAndConditions',
  },
  termsAndPrivacy: {
    defaultMessage: 'Terms and privacy',
    id: 'LegalDisclaimer.termsAndPrivacy',
  },
  paymentTermsAndPolicy: {
    defaultMessage: `Read Tink’s {termsAndConditions} and {privacyPolicy}.`,
    id: 'PaymentConsentScreen.paymentTermsAndPolicy',
  },
  paymentConsentTitle: {
    defaultMessage: '{clientName} uses Tink to make the payment',
    id: 'PaymentConsentScreen.paymentConsentTitle',
  },
  payByBankTitle: {
    defaultMessage: 'Pay by bank',
    id: 'PaymentConsentScreen.payByBankTitle',
  },
  paymentConsentInstruction: {
    defaultMessage: 'Click continue to log in to your bank and securely complete the payment.',
    id: 'PaymentConsentScreen.paymentConsentInstruction',
  },
  vrpConsentTitle: {
    defaultMessage: '{clientName} uses Tink to set up your payment',
    id: 'VrpConsentScreen.vrpConsentTitle',
  },
  vrpConsentInstruction: {
    defaultMessage: 'You will set up a Variable Recurring Payment mandate.',
    id: 'VrpConsentScreen.vrpConsentInstruction',
  },
  vrpByClicking: {
    defaultMessage: `By clicking "Continue", you agree to Tink's {termsAndConditions} and {privacyPolicy}.`,
    id: 'VrpConsentScreen.vrpByClicking',
  },
  vrpReadMoreH1: {
    defaultMessage: 'About your Variable Recurring Payment (VRP) mandate',
    id: 'VrpConsentScreen.vrpReadMoreH1',
  },
  vrpReadMoreP1: {
    defaultMessage:
      'By signing the VRP mandate, you give Tink permission to initiate payments between the specified accounts.',
    id: 'VrpConsentScreen.vrpReadMoreP1',
  },
  vrpReadMoreH2: {
    defaultMessage: 'What is a VRP mandate?',
    id: 'VrpConsentScreen.vrpReadMoreH2',
  },
  vrpReadMoreP2: {
    defaultMessage:
      'A VRP mandate consists of a set of payment parameters that limit the payments that can be made between accounts. Any payment taken from your account must meet these constraints.',
    id: 'VrpConsentScreen.vrpReadMoreP2',
  },
  vrpReadMoreH3: {
    defaultMessage: 'How can you cancel the mandate?',
    id: 'VrpConsentScreen.vrpReadMoreH3',
  },
  vrpReadMoreP3: {
    defaultMessage:
      'You can view and cancel the VRP mandate in your banking app whenever you want.',
    id: 'VrpConsentScreen.vrpReadMoreP3',
  },
  vrpSummaryToConfirm: {
    defaultMessage: 'To confirm, log in to {clientName}',
    id: 'VrpConsentScreen.vrpSummaryToConfirm',
  },
  vrpSummaryPayingTo: {
    defaultMessage: 'Paying to',
    id: 'PaymentInfoContainer.payingTo',
  },
  vrpSummaryPayingFrom: {
    defaultMessage: 'Paying from',
    id: 'PaymentInfoContainer.payingFrom',
  },
  vrpSummaryDetails: {
    defaultMessage: 'Details',
    id: 'Alert.details',
  },
  vrpSummaryAccountInformation: {
    defaultMessage: 'Account information',
    id: 'VrpConsentScreen.vrpSummaryAccountInformation',
  },
  vrpSummaryAccountNumber: {
    defaultMessage: 'Account number',
    id: 'VrpConsentScreen.vrpSummaryAccountNumber',
  },
  vrpSummarySortCode: {
    defaultMessage: 'Sort code',
    id: 'VrpConsentScreen.vrpSummarySortCode',
  },
  vrpSummaryPaymentMandate: {
    defaultMessage: 'Payment mandate',
    id: 'VrpConsentScreen.vrpSummaryPaymentMandate',
  },
  vrpSummaryStartDate: {
    defaultMessage: 'Start date',
    id: 'VrpConsentScreen.vrpSummaryStartDate',
  },
  vrpSummaryEndDate: {
    defaultMessage: 'End date',
    id: 'VrpConsentScreen.vrpSummaryEndDate',
  },
  vrpSummaryMaxAmountPerPayment: {
    defaultMessage: 'Max amount per payment',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerPayment',
  },
  vrpSummaryReference: {
    defaultMessage: 'Reference',
    id: 'VrpConsentScreen.vrpSummaryReference',
  },
  vrpSummaryMaxAmountPerDay: {
    defaultMessage: 'Max amount per {day}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerDay',
  },
  vrpSummaryMaxAmountPerWeek: {
    defaultMessage: 'Max amount per {week}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerWeek',
  },
  vrpSummaryMaxAmountPerFortnight: {
    defaultMessage: 'Max amount per {fortnight}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerFortnight',
  },
  vrpSummaryMaxAmountPerMonth: {
    defaultMessage: 'Max amount per {month}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerMonth',
  },
  vrpSummaryMaxAmountPerHalfYear: {
    defaultMessage: 'Max amount per {halfYear}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerHalfYear',
  },
  vrpSummaryMaxAmountPerYear: {
    defaultMessage: 'Max amount per {year}',
    id: 'VrpConsentScreen.vrpSummaryMaxAmountPerYear',
  },
  vrpSummaryDay: {
    defaultMessage: 'day',
    id: 'VrpConsentScreen.vrpSummaryDay',
  },
  vrpSummaryWeek: {
    defaultMessage: 'week',
    id: 'VrpConsentScreen.vrpSummaryWeek',
  },
  vrpSummaryFortnight: {
    defaultMessage: 'fortnight',
    id: 'VrpConsentScreen.vrpSummaryFortnight',
  },
  vrpSummaryMonth: {
    defaultMessage: 'month',
    id: 'VrpConsentScreen.vrpSummaryMonth',
  },
  vrpSummaryHalfYear: {
    defaultMessage: 'half year',
    id: 'VrpConsentScreen.vrpSummaryHalfYear',
  },
  vrpSummaryYear: {
    defaultMessage: 'year',
    id: 'VrpConsentScreen.vrpSummaryYear',
  },
  vrpSummaryRenewsWeekly: {
    defaultMessage: 'Renews weekly on {day}',
    id: 'VrpConsentScreen.vrpSummaryRenewsWeekly',
  },
  vrpSummaryRenewsBiWeekly: {
    defaultMessage: 'Renews bi-weekly on {day}',
    id: 'VrpConsentScreen.vrpSummaryRenewsBiWeekly',
  },
  vrpSummaryRenewsMonthly: {
    defaultMessage: 'Renews monthly on {date}',
    id: 'VrpConsentScreen.vrpSummaryRenewsMonthly',
  },
  vrpSummaryRenewsHalfYearly: {
    defaultMessage: 'Renews half-yearly on {date}',
    id: 'VrpConsentScreen.vrpSummaryRenewsHalfYearly',
  },
  vrpSummaryRenewsYearly: {
    defaultMessage: 'Renews yearly on {date}',
    id: 'VrpConsentScreen.vrpSummaryRenewsYearly',
  },
  confirm: {
    defaultMessage: 'Confirm',
    id: 'ExtendConsent.confirm',
  },
  today: {
    defaultMessage: 'Today',
    id: 'VrpConsentScreen.today',
  },
  ongoing: {
    defaultMessage: 'Ongoing',
    id: 'VrpConsentScreen.ongoing',
  },
  vrpSuccessScreenAllDone: {
    defaultMessage: 'All done!',
    id: 'VrpSuccessScreen.allDone',
  },
  vrpSuccessScreenReferenceId: {
    defaultMessage: 'Your reference ID',
    id: 'VrpSuccessScreen.referenceId',
  },
  handoffScreenScanSymbol: {
    defaultMessage: 'Scan the symbol to continue',
    id: 'HandoffScreen.scanSymbol',
  },
  handoffScreenDoNotHaveAPhone: {
    defaultMessage: "I don't have a phone",
    id: 'HandoffScreen.doNotHaveAPhone',
  },
  vrpMandateSetupFailed: {
    defaultMessage: 'Payment set-up failed',
    id: 'VrpMandateSetupFailed',
  },
  verifyWithBank: {
    defaultMessage: 'Verify with your bank',
    id: 'ConsentScreen.verifyWithBank',
  },
  connectToBank: {
    defaultMessage: 'Connect to bank',
    id: 'ConsentScreen.connectToBank',
  },
  connectMessage: {
    defaultMessage:
      "We'll connect you to your bank. You'll verify your payment with them directly.",
    id: 'ConsentScreen.connectMessage',
  },
  paymentMessage: {
    defaultMessage:
      'Payment will be processed on a secure server. Your bank credentials will not be shared with Netflix.',
    id: 'ConsentScreen.paymentMessage',
  },
  signupMessage: {
    defaultMessage: 'Come back to Netflix to complete sign up.',
    id: 'ConsentScreen.signupMessage',
  },
  merchantConsentTitle: {
    defaultMessage: 'Pay by bank',
    id: 'MerchantConsentScreen.merchantConsentTitle',
  },
  merchantConsentPaymentsTitle: {
    defaultMessage: 'Secure payments',
    id: 'MerchantConsentScreen.merchantConsentPaymentsTitle',
  },
  merchantConsentPaymentsText: {
    defaultMessage: 'Click continue to log in to your bank and securely complete the payment.',
    id: 'MerchantConsentScreen.merchantConsentPaymentsText',
  },
  merchantConsentTermsTitle: {
    defaultMessage: 'Terms and privacy',
    id: 'MerchantConsentScreen.merchantConsentTermsTitle',
  },
  merchantConsentTermsText: {
    defaultMessage:
      'We use {clientName} to make the payment. {termsAndConditions} and {privacyPolicy}.',
    id: 'MerchantConsentScreen.merchantConsentTermsText',
  },
  merchantConsentTermsLabel: {
    defaultMessage: 'Terms and Conditions',
    id: 'MerchantConsentScreen.merchantConsentTermsLabel',
  },
  merchantConsentPolicyLabel: {
    defaultMessage: 'Privacy Policy',
    id: 'MerchantConsentScreen.merchantConsentPolicyLabel',
  },
  paymentConsentTermsText: {
    defaultMessage: `By selecting "Continue", you agree to Tink's {termsAndConditions} and {privacyPolicy}.`,
    id: 'PaymentConsentScreen.paymentConsentTermsText',
  },
  paymentConsentScreenTitle: {
    defaultMessage: '{clientName} uses Tink to make your payment',
    id: 'PaymentConsentScreen.paymentConsentScreenTitle',
  },
  paymentConsentScreenInfo: {
    defaultMessage: 'Payment will be made directly from your bank account',
    id: 'PaymentConsentScreen.paymentConsentScreenInfo',
  },
  paymentConsentScreenNextStep: {
    defaultMessage: 'Next you will be asked to confirm your identity and payment amount',
    id: 'PaymentConsentScreen.paymentConsentScreenNextStep',
  },
});
